import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, Package, Users, FolderOpen, ArrowLeft, UserPlus } from 'lucide-react';
import ProductManagement from '../components/admin/ProductManagement';
import UserManagement from '../components/admin/UserManagement';
import ProjectManagement from '../components/admin/ProjectManagement';
import CustomerManagement from '../components/admin/CustomerManagement';
import './AdminPage.css';

const AdminPage = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState('products');

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user') || 'null');
    if (!storedUser) {
      navigate('/login');
    } else if (storedUser.role === 'engineer') {
      // Redirect engineers to their dashboard
      navigate('/engineer');
    } else {
      setUser(storedUser);
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/');
  };

  if (!user) return null;

  const tabs = [
    { id: 'products', label: 'Διαχείριση Προϊόντων', icon: Package },
    { id: 'customers', label: 'Πελάτες / CRM', icon: UserPlus },
    { id: 'users', label: 'Χρήστες', icon: Users },
    { id: 'projects', label: 'Φάκελοι Έργων', icon: FolderOpen }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'products':
        return <ProductManagement />;
      case 'customers':
        return <CustomerManagement />;
      case 'users':
        return <UserManagement />;
      case 'projects':
        return <ProjectManagement />;
      default:
        return <ProductManagement />;
    }
  };

  return (
    <div className="admin-page">
      <header className="admin-header">
        <button 
          className="back-to-home-admin"
          onClick={() => navigate('/')}
          aria-label="Επιστροφή στην αρχική"
        >
          <ArrowLeft size={20} />
          <span>Αρχική</span>
        </button>

        <h1>Admin Panel</h1>

        <div className="admin-user-info">
          <span>Χρήστης: {user.username}</span>
          <button 
            className="logout-button"
            onClick={handleLogout}
            aria-label="Αποσύνδεση"
          >
            <LogOut size={18} />
            <span>Αποσύνδεση</span>
          </button>
        </div>
      </header>

      <div className="admin-tabs">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              className={`admin-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <Icon size={20} />
              <span>{tab.label}</span>
            </button>
          );
        })}
      </div>

      <main className="admin-content">
        {renderTabContent()}
      </main>
    </div>
  );
};

export default AdminPage;
